import React, { useState, useEffect } from 'react';
import ActionButton from '../../component/action-button';
import { ToastSuccess, ToastError } from "../../component/toast-notification";
import { connect } from 'react-redux';
import { loader } from '../../Actions/index';
import store from '../../store';
import { CreateDeCategory, GetAllDeCategory, UpdateDeCategory, CreateDeSubCategory, uploadImage } from '../../api/apiService';

const mapStateToProps = (store) => {
    return {
        loaderDisplay: store.loaderDisplay
    }
}

const DeCategory = ({ loaderDisplay }) => {
    const [categories, setCategories] = useState([]);
    const [categoryName, setCategoryName] = useState("");
    const [categoryImage, setCategoryImage] = useState(null);
    const [categoryRowImage, setCategoryRowImage] = useState(null);
    const [addSubCategory, setAddSubCategory] = useState("");
    const [subCategoryImage, setSubCategoryImage] = useState(null);
    const [subCategoryRowImage, setSubCategoryRowImage] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmitOne, setIsSubmitOne] = useState(false);
    const [categoryId, setCategoryId] = useState("");
    const [dropMenu, setDropMenu] = useState(false);
    const [selectValue, setSelectValue] = useState([]);
    const [searchCategoryList, setSearchCategoryList] = useState([]);
    const [searchText, setSearchText] = useState("");

    // Fetch categories on component mount
    useEffect(() => {
        fetchCategory();
    }, []);

    const handleAddCategory = (ev) => {
        setCategoryName(ev.target.value);
        if (isSubmitted) {
            validCategory();
        }
    }

    const hendleClear = () => {
        setCategoryName("");
        setCategoryImage(null);
        setCategoryRowImage(null);
        setCategoryId("");
        setIsSubmitOne(false);
        setAddSubCategory("");
        setSubCategoryImage(null);
        setSubCategoryRowImage(null);
        setSelectValue([]);
        setSearchText("");
        setIsSubmitted(false);
    }

    const onCategoryImageChange = event => {
        if (event.target.files && event.target.files[0]) {
            let img = event.target.files[0];
            setCategoryImage(URL.createObjectURL(img));
            setCategoryRowImage(img);
            if (isSubmitted) {
                validCategory();
            }
        }
    };

    const onSubCategoryImageChange = event => {
        if (event.target.files && event.target.files[0]) {
            let img = event.target.files[0];
            setSubCategoryImage(URL.createObjectURL(img));
            setSubCategoryRowImage(img);
            if (isSubmitOne) {
                validSubCategory();
            }
        }
    };

    const handleAddSubCategory = (event) => {
        setAddSubCategory(event.target.value);
        if (isSubmitOne) {
            validSubCategory();
        }
    }

    const handleSearch = (e) => {
        let filter = e.target.value.toUpperCase();
        let list = categories;
        let arr = [];
        for (var i = 0; i < list.length; i++) {
            let a = list[i].name.toUpperCase();
            if (a.indexOf(filter) > -1) {
                arr.push(list[i]);
            }
        }
        setSearchCategoryList(arr);
        setSearchText(filter);
    }

    // Validation functions
    const validCategory = () => {
        let checked = true;
        if (categoryName.length < 1) {
            checked = false;
        }
        if (categoryImage === null) {
            checked = false;
        }
        return checked;
    }

    const validSubCategory = () => {
        let checkedOne = true;
        if (selectValue.length === 0) {
            checkedOne = false;
        }
        if (addSubCategory.length < 1) {
            checkedOne = false;
        }
        if (subCategoryImage === null) {
            checkedOne = false;
        }
        return checkedOne;
    }

    // API call
    const fetchCategory = async () => {
        try {
            store.dispatch(loader(true));
            const category = await GetAllDeCategory(searchText);
            setCategories(category.data.data);
            store.dispatch(loader(false));
        } catch (error) {
            console.log(error);
            store.dispatch(loader(false));
        }
    }

    // Submit functions
    const submitCategory = async () => {
        setIsSubmitted(true);
        if (validCategory()) {
            try {
                var data;
                if (categoryRowImage) {
                    const img = await uploadImage(categoryRowImage, "categories");
                    data = {
                        "name": categoryName,
                        "image": img.data.data.location
                    }
                } else {
                    data = {
                        "name": categoryName,
                        "image": categoryImage
                    }
                }

                if (categoryId === "") {
                    const createCategory = await CreateDeCategory(data);
                    if (createCategory.data.status === 200) {
                        fetchCategory();
                        hendleClear();
                        ToastSuccess(createCategory.data.msg);
                    } else {
                        ToastError(createCategory.data.msg);
                    }
                } else {
                    const categoryUpdate = await UpdateDeCategory(categoryId, data);
                    fetchCategory();
                    hendleClear();
                    ToastSuccess(categoryUpdate.data.msg);
                }
            } catch (ex) {
                console.log(ex);
                ToastError(ex.response.data.msg);
            }
        }
    }

    const submitSubCategory = async () => {
        setIsSubmitOne(true);
        if (validSubCategory()) {
            try {
                var data;
                if (subCategoryRowImage) {
                    const img = await uploadImage(subCategoryRowImage, "subcategories");
                    data = {
                        "name": addSubCategory,
                        "image": img.data.data.location
                    }
                } else {
                    data = {
                        "name": addSubCategory,
                        "image": subCategoryImage
                    }
                }

                const createSubCategory = await CreateDeSubCategory(selectValue[0]._id, data);
                fetchCategory();
                hendleClear();
                ToastSuccess(createSubCategory.data.msg);
            } catch (error) {
                console.log(error);
                ToastError(error.response.data.msg);
            }
        }
    }

    const handleCategoryEdit = (item) => {
        setCategoryId(item._id);
        setCategoryName(item.name);
        setCategoryImage(item.image);
        setCategoryRowImage(null);
    }

    const handleCategorySelect = (item) => {
        setSelectValue([item]);
        if (isSubmitOne) {
            validSubCategory();
        }
    }

    return (
        <div className="my-4">
            <div className="row">
                <div className='col-sm-8'>
                    <div className="category-container ">
                        <h2 className="text-secondary">Categories</h2>
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>Image</th>
                                    <th>Category</th>
                                    <th>Sub Category</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {categories?.map(item => {
                                    return <tr key={item._id}>
                                        <td>
                                            <img src={item.image ? item.image : "/assate/images/food-logo.png"} className="table-img" alt="" />
                                        </td>
                                        <td>{item.name}</td>
                                        <td>
                                            {item.subCategory && item.subCategory?.map((sub, index) => {
                                                return (
                                                    <div key={index} className="d-flex align-items-center mb-1">
                                                        <img
                                                            src={sub.image ? sub.image : "/assate/images/food-logo.png"}
                                                            className="subcategory-img mr-1"
                                                            alt=""
                                                            style={{ width: '20px', height: '20px', borderRadius: '3px' }}
                                                        />
                                                        <span className="badge bg-btn-color p-1 mr-1">
                                                            {sub.name}
                                                            <i className="demo-icon mx-1 cursor-pointer">&#xe808;</i>
                                                        </span>
                                                    </div>
                                                )
                                            })}
                                        </td>
                                        <td className="text-center">
                                            {item.isActive ?
                                                <span className="badge badge-success">Active</span> :
                                                <span className="badge badge-danger">Inactive</span>
                                            }
                                        </td>
                                        <td>
                                            <span onClick={() => handleCategoryEdit(item)}>
                                                <ActionButton>
                                                    <i className="demo-icon icon-edit text-primary">&#xe80f;</i>
                                                </ActionButton>
                                            </span>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='col-sm-4'>
                    <div className="add-category-sticky">
                        <div className="category-container mb-3">
                            <div className="d-flex justify-content-between">
                                <h5 className="text-secondary ml-2">Create category</h5>
                                {categoryId === "" ? "" : <button onClick={() => hendleClear()} className="clear-btn">Clear</button>}
                            </div>
                            <div className="category-field">
                                <label className="font-12 m-0">Category</label>
                                <div className="form-group d-flex m-0">
                                    <div className="category-image-container">
                                        <div>
                                            <label className="upload-category-image cursor-pointer" htmlFor="categoryFile">
                                                <img src={categoryImage} alt=""
                                                    style={categoryImage === null && isSubmitted ? { border: "1px solid red" } : {}}
                                                    className="category-image" />
                                                <i style={categoryImage != null ? { color: "transparent" } : {}}
                                                    className="demo-icon icon-camera">&#xe807;</i>
                                                <input type="file" id="categoryFile" accept="image/*" onChange={(e) => onCategoryImageChange(e)} />
                                            </label>
                                        </div>
                                    </div>
                                    <input
                                        onChange={(ev) => handleAddCategory(ev)}
                                        style={categoryName.length < 1 && isSubmitted ? { border: "1px solid red" } : {}}
                                        type="text"
                                        value={categoryName}
                                        className="form-control"
                                        placeholder="Category" />
                                </div>
                                <div className="text-right">
                                    <button onClick={() => submitCategory()} className="btn btn-verify mt-2 ">
                                        {categoryId === "" ? "Add" : "Update"}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="category-container">
                            <h5 className="text-secondary ml-2">Create Sub Category</h5>
                            <div className="category-field">
                                <label className="font-12 m-0">Select Category</label>

                                <div className="select-box">
                                    <div
                                        className="options-container"
                                        style={dropMenu ? {} : { display: "none" }}>
                                        {searchCategoryList.length === 0 && searchText === "" ?
                                            categories?.map((item, i) => {
                                                return (
                                                    <div
                                                        className="option"
                                                        key={item._id}
                                                        onClick={() => handleCategorySelect(item)}
                                                    >
                                                        <label className="ml-1 text-capitalize">{item.name}</label>
                                                    </div>
                                                );
                                            })
                                            :
                                            searchCategoryList?.map((item, i) => {
                                                return (
                                                    <div
                                                        className="option"
                                                        key={item._id}
                                                        onClick={() => handleCategorySelect(item)}
                                                    >
                                                        <label className="ml-1 text-capitalize">{item.name}</label>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                    <div className="selected"
                                        onClick={() => setDropMenu(!dropMenu)}
                                        style={selectValue.length === 0 && isSubmitOne ? { border: "1px solid red", borderRadius: "4px" } : { border: "1px solid #cccccc", borderRadius: "4px" }}
                                    >
                                        {(dropMenu && selectValue.length) >= 1 || (!dropMenu && selectValue.length) >= 1 ? "" : "Select Category"}
                                        {selectValue?.map((m, i) => {
                                            return <span className="badge bg-warning text-dark mx-1 text-capitalize" key={i}>
                                                {m.name}
                                            </span>
                                        })}
                                    </div>
                                    <div
                                        className="search-box"
                                        style={dropMenu ? {} : { display: "none" }}
                                    >
                                        <input
                                            onKeyUp={(e) => handleSearch(e)}
                                            type="search"
                                            placeholder="Search ..."
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="category-field">
                                <div className="form-group d-flex m-0">
                                    <div className="category-image-container">
                                        <div>
                                            <label className="upload-category-image cursor-pointer" htmlFor="subCategoryFile">
                                                <img src={subCategoryImage} alt=""
                                                    style={subCategoryImage === null && isSubmitted ? { border: "1px solid red" } : {}}
                                                    className="category-image" />
                                                <i style={subCategoryImage != null ? { color: "transparent" } : {}}
                                                    className="demo-icon icon-camera">&#xe807;</i>
                                                <input type="file" id="subCategoryFile" accept="image/*" onChange={(e) => onSubCategoryImageChange(e)} />
                                            </label>
                                        </div>
                                    </div>
                                    <input
                                        onChange={(e) => { handleAddSubCategory(e) }}
                                        style={addSubCategory.length < 1 && isSubmitOne ? { border: "1px solid red" } : {}}
                                        type="text"
                                        value={addSubCategory}
                                        className="form-control"
                                        placeholder="Sub Category" id="usr" />
                                </div>
                                <div className="text-right">
                                    <button onClick={() => submitSubCategory()} className="btn btn-verify mt-2">Add</button>
                                </div>
                            </div>
                            {/* <div className="category-field">
                            <div className="form-group m-0">
                                <label className="font-12 m-0">Sub Category Image</label>
                                <div className="subcategory-image-container mb-2">
                                    <label className="upload-subcategory-image cursor-pointer" htmlFor="subCategoryFile">
                                        <img src={subCategoryImage} alt=""
                                            style={subCategoryImage === null && isSubmitOne ? { border: "1px solid red" } : {}}
                                            className="subcategory-image" />
                                        <i style={subCategoryImage != null ? { color: "transparent" } : {}}
                                            className="demo-icon icon-camera">&#xe807;</i>
                                        <input type="file" id="subCategoryFile" accept="image/*" onChange={(e) => onSubCategoryImageChange(e)} />
                                    </label>
                                </div>
                                <label className="font-12 m-0">Sub Category Name</label>
                                <input
                                    onChange={(e) => { handleAddSubCategory(e) }}
                                    style={addSubCategory.length < 1 && isSubmitOne ? { border: "1px solid red" } : {}}
                                    type="text"
                                    value={addSubCategory}
                                    className="form-control"
                                    placeholder="Sub Category" id="usr" />
                            </div>
                            <div className="text-right">
                                <button onClick={() => submitSubCategory()} className="btn btn-verify mt-2">Add</button>
                            </div>
                        </div> */}
                        </div>

                    </div>
                </div>
            </div>
        </div >
    );
}

export default connect(mapStateToProps)(DeCategory);